// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalysisApplicationController from "./analysis_application_controller"
application.register("analysis-application", AnalysisApplicationController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IdealPostcodesAddressController from "./ideal_postcodes_address_controller"
application.register("ideal-postcodes-address", IdealPostcodesAddressController)

import ExistingCustomerResolutionController from "./existing_customer_resolution_controller"
application.register("existing-customer-resolution", ExistingCustomerResolutionController)

import ImagePositionController from "./image_position_controller"
application.register("image-position", ImagePositionController)

import CustomerImportUploadProgressController from "./customer_import_upload_progress_controller"
application.register("customer-import-upload-progress", CustomerImportUploadProgressController)
